const refs = {
    pagiContainer: document.querySelector('#tui-pagination-container'),
    wachedBtn: document.querySelector('.js-watched'),
    queueBtn: document.querySelector('.js-queue'),
    gallery: document.querySelector('.gallery'),
};
export const { pagiContainer, wachedBtn, queueBtn, gallery } = refs;
